module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    ref: "networksFilterModal"
  }, [_c('div', {
    staticClass: "viewership-filter"
  }, [_c('tabs', [_c('tab', {
    attrs: {
      "name": "Turner"
    }
  }, [_c('div', {
    staticClass: "viewership-filter__networks-container"
  }, _vm._l((_vm.turnerNetworks), function(network) {
    return _c('button', {
      key: network.id,
      staticClass: "viewership-filter__network",
      class: {
        'viewership-filter__network--selected': _vm.isSelected(network.id)
      },
      on: {
        "click": function($event) {
          return _vm.selectNetwork(network.id)
        }
      }
    }, [(_vm.hasUrl(network)) ? _c('img', {
      attrs: {
        "src": network.url
      }
    }) : [_vm._v(_vm._s(network.name))]], 2)
  }), 0)]), _vm._v(" "), _c('tab', {
    attrs: {
      "name": "Non-Turner"
    }
  }, [_c('div', {
    staticClass: "viewership-filter__networks-container"
  }, _vm._l((_vm.nonTurnerNetworks), function(network) {
    return _c('button', {
      key: network.id,
      staticClass: "viewership-filter__network__non-turner non-turner",
      class: {
        'viewership-filter__network--selected': _vm.isSelected(network.id)
      },
      on: {
        "click": function($event) {
          return _vm.selectNetwork(network.id)
        }
      }
    }, [(_vm.hasUrl(network)) ? _c('img', {
      attrs: {
        "src": network.url
      }
    }) : [_vm._v(_vm._s(network.name))]], 2)
  }), 0)])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "viewership-filter__actions",
    attrs: {
      "slot": "actions"
    },
    slot: "actions"
  }, [(_vm.errorNoNetworks) ? _c('v-alert', {
    staticStyle: {
      "margin-bottom": "0"
    },
    attrs: {
      "dense": "",
      "text": "",
      "type": "warning"
    }
  }, [_vm._v("Please select at least one network")]) : _vm._e(), _vm._v(" "), (_vm.errorToManySelected) ? _c('v-alert', {
    staticStyle: {
      "margin-bottom": "0"
    },
    attrs: {
      "dense": "",
      "text": "",
      "type": "warning"
    }
  }, [_vm._v("Please narrow your selection from " + _vm._s(_vm.currentLength) + " to " + _vm._s(_vm.maxNumberOfNetworks) + " or less")]) : _vm._e(), _vm._v(" "), _c('action-button', {
    attrs: {
      "label": "cancel",
      "id": "cancelNetworkSelection",
      "color": "secondary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.close.apply(null, arguments)
      }
    }
  }), _vm._v(" "), _c('action-button', {
    attrs: {
      "disabled": _vm.disableSubmit,
      "label": "update",
      "id": "updateNetworkSelection",
      "color": "success"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.submitNewSelection.apply(null, arguments)
      }
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-39284a85"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/appComponents/workbench/lasGraphs/viewership/components/ViewershipFilter.vue
// module id = 1864
// module chunks = 0